<template>
  <div class="orderDetail">
    <md-popup
      class="orderDetail_pop"
      v-model="isPopupShow"
      position="right"
      :mask-closable="true"
      @beforeHide="closePop"
    >
      <div class="detailBox">
        <!-- 标题 -->
        <div class="titleBox">
          <md-icon name="wrong" size="sm" @click="closePop"></md-icon>
          <span class="title">订单详情</span>
          <span class="printer" @click="orderPrint">重打小票</span>
        </div>
        <!-- 内容区 -->
        <div class="contentBox" v-if="detailList && detailList.id">
          <!-- 订单信息 -->
          <div class="orderInfoBox">
            <div class="orderInfoTitle">
              <span>订单信息</span>
              <span>日单号：{{detailList.day_num}}</span>
            </div>
            <div class="orderInfoContent">
              <div class="tit_b">
                <div class="mand-ellipsis" style="width:4rem">
                  <span>{{detailList.buyer_name}}</span>
                </div>
                <div>
                  <span>￥</span>
                  <span>{{detailList.amount*1||0}}</span>
                </div>
              </div>
              <div class="price_box">
                <div>
                  <span>商品总价:</span>
                  <span style="font-size:0.16rem">￥</span>
                  <span>{{detailList.receivables*1||0}}</span>
                </div>
                <div v-if="detailList.discount!=0">
                  <span v-if="detailList.discount<0">订单优惠:</span>
                  <span v-if="detailList.discount>0">订单多收:</span>
                  <span style="font-size:0.16rem">￥</span>
                  <span>{{Math.abs(Number(detailList.discount))}}</span>
                </div>
              </div>
              <div class="price_box">
                <div>
                  <span>实收:</span>
                  <span style="font-size:0.16rem">￥</span>
                  <span>{{detailList.real_price*1||0}}</span>
                </div>
              </div>
              <div class="price_box">
                <div>
                  <span>赊欠:</span>
                  <span style="color:#f79a07;font-size:0.16rem">￥</span>
                  <span style="color:#f79a07;">{{detailList.last_credit*1||0}}</span>
                </div>
              </div>

              <div v-if="detailList.annal" class="line_y">
                <div class="credit_discount">
                  <div>
                    <span>还款优惠:</span>
                    <span>￥</span>
                    <span>{{Number(detailList.annal[0].discount_amount)}}</span>
                  </div>
                </div>
              </div>

              <div class="order_people">收银员：{{detailList.user_realname}}</div>
              <div class="desc_box" v-if="detailList.remarks">
                <span>备注：</span>
                <span>{{detailList.remarks}}</span>
              </div>
              <div class="order_num order_time">订单编号：{{detailList.order_sn}}</div>
              <div class="order_time">结账时间：{{detailList.create_time|toTime}}</div>
            </div>
          </div>

          <div class="bgg"></div>
          <!-- 货品明细 -->
          <div class="goodsDetailBox">
            <div class="tit">
              <span>货品明细</span>
            </div>
            <div class="goodsList">
              <div class="list" v-for="(item,i) in detailList.goods" :key="i">
                <div class="name">
                  <div class>
                    <span class="goods_name">{{item.name}}</span>
                    <div class="goods_item_type" style="margin-left:0.1rem">
                      <span
                        class="goods_item_type_1"
                        v-if="item.bale ==1 && item.goods_type == 1"
                      >定装</span>
                      <span
                        class="goods_item_type_2"
                        v-if="item.bale ==2 && item.goods_type == 1"
                      >非定装</span>
                      <span
                        class="goods_item_type_3"
                        v-if="item.bale ==3 && item.goods_type == 1"
                      >散装</span>
                      <span class="goods_item_type_4" v-if="item.goods_type == 2">附加费</span>
                    </div>
                    <div
                      class="goods_item_type"
                      style="margin-left:0.1rem"
                      v-if="item.goods_type == 1"
                    >
                      <span class="item_type_zy" v-if="item.type == 1">自营</span>
                      <span class="item_type_dm" v-if="item.type == 2">代卖</span>
                    </div>
                  </div>
                  <div>
                    <span>小计：</span>
                    <span style="color:#31b158;font-size:0.16rem">￥</span>
                    <span class="total">{{item.goods_total_price*1||0}}</span>
                  </div>
                </div>
                <!--  -->
                <div class="batch">
                  <div>
                    <span v-if="item.batch">批次号：{{item.batch || '暂无'}}</span>
                  </div>
                  <div>操作员：{{item.user_realname}}</div>
                </div>
                <!--  -->
                <div class="bale">
                  <table border="1" cellspacing="0" v-if="item.goods_type == 1">
                    <tr v-if="item.bale==1">
                      <td>数量({{unit_list[item.num_unit-1].name}})</td>
                      <td>规格(公斤/{{unit_list[item.num_unit-1].name}})</td>
                      <td>单价(元/{{unit_list[item.num_unit-1].name}})</td>
                    </tr>
                    <tr v-if="item.bale==2">
                      <td>数量({{unit_list[item.num_unit-1].name}})</td>
                      <td>重量(公斤)</td>
                      <td>单价(元/公斤)</td>
                    </tr>
                    <tr v-if="item.bale==3">
                      <td>重量(公斤)</td>
                      <td>单价(元/公斤)</td>
                    </tr>
                    <tr v-if="item.bale==1">
                      <td>{{item.num*1}}</td>
                      <td>{{item.bale_num*1}}</td>
                      <td>{{Number(item.price)}}</td>
                    </tr>
                    <tr v-if="item.bale==2">
                      <td>{{item.num*1}}</td>
                      <td>{{item.weight*1}}</td>
                      <td>{{Number(item.price)}}</td>
                    </tr>
                    <tr v-if="item.bale==3">
                      <td>{{item.weight*1}}</td>
                      <td>{{Number(item.price)}}</td>
                    </tr>
                  </table>
                  <table border="1" cellspacing="0" v-if="item.goods_type == 2">
                    <tr>
                      <td v-if="item.type == 1 ">数量</td>
                      <td v-if="item.type == 1 ">单价</td>
                      <td v-if="item.type == 2 ">数量</td>
                      <td v-if="item.type == 2 ">金额</td>
                    </tr>
                    <tr>
                      <td v-if="item.type == 1">{{Number(item.num)}}个</td>
                      <td v-if="item.type == 1">{{Number(item.price)}}元/个</td>
                      <td v-if="item.type == 2">-</td>
                      <td v-if="item.type == 2">{{Number(item.price)}}元</td>
                    </tr>
                  </table>
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <!-- 订单追向 -->
          <div class="goodsDetailBox orderPart3">
            <div class="tit">
              <span>订单动向</span>
            </div>
            <div class="contentPart3">
              <el-timeline :reverse="false">
                <el-timeline-item size="large" placement="center" v-if="detailList.status == 4">
                  <div class>被改单</div>
                  <div>操作人员：{{detailList.ouid_realname}}</div>
                  <div @click="tobefore(detailList.order_sn,1)" style="color:rgb(227, 98, 9)">查看改单后</div>
                </el-timeline-item>
                <el-timeline-item size="large" placement="top" v-if="detailList.status == 3">
                  <div>{{detailList.update_time | toTime}}</div>
                  <div class>作废</div>
                  <div>操作人员：{{detailList.ouid_realname}}</div>
                </el-timeline-item>
                <el-timeline-item size="large" placement="top" v-if="detailList.annal">
                  <div
                    v-for="(item,index) in detailList.annal"
                    :key="index"
                    style="margin-bottom:0.2rem"
                  >
                    <div>{{item.create_time | toTime}}</div>
                    <div>还款</div>
                    <div>操作人员：{{item.user_name}}</div>
                    <!-- <div>订单金额：{{detailList.amount}}元</div> -->
                    <div>赊欠金额：{{item.credit_amount*1}}元</div>
                    <div>还款优惠：{{item.discount_amount*1}}元</div>
                    <div>还款金额：{{item.repayment*1}}元</div>
                    <div>剩余欠款：{{item.need_repayment_amount*1}}元</div>
                    <div
                      v-if="detailList.status && detailList.need_repayment_amount != detailList.order_amount"
                    >
                      支付方式：
                      <span v-if="item.type == 1">现金</span>
                      <span v-if="item.type == 2">支付宝</span>
                      <span v-if="item.type == 3">微信</span>
                      <span v-if="item.type == 4">银行卡</span>
                      <span v-if="item.type == 5">POS</span>
                      <span v-if="item.type == 51">POS</span>
                      <span v-if="item.type == 52">POS</span>
                      <span v-if="item.type == 53">POS</span>
                    </div>
                  </div>
                </el-timeline-item>
                <el-timeline-item size="large" placement="top" v-if="!detailList.before_sn">
                  <div>{{detailList.create_time | toTime}}</div>
                  <div>收银</div>
                  <div>订单金额：{{detailList.amount*1}}元</div>
                  <div>商品金额：{{detailList.receivables*1}}元</div>
                  <div v-if="detailList.discount<0">优惠金额：{{-detailList.discount*1}}元</div>
                  <div v-if="detailList.discount>0">多收金额：{{detailList.discount*1}}元</div>
                  <div>支付金额：{{detailList.payment*1}}元</div>
                  <div>赊欠金额：{{detailList.credit*1||0}}元</div>
                  <div
                    v-if="detailList.status && detailList.credit != detailList.order_amount"
                  >
                    支付方式：
                    <span v-if="detailList.pay_type == 1">现金</span>
                    <span v-if="detailList.pay_type == 2">支付宝</span>
                    <span v-if="detailList.pay_type == 3">微信</span>
                    <span v-if="detailList.pay_type == 4">银行卡</span>
                    <span v-if="detailList.pay_type == 5">POS</span>
                    <span v-if="detailList.pay_type == 51">POS</span>
                    <span v-if="detailList.pay_type == 52">POS</span>
                    <span v-if="detailList.pay_type == 53">POS</span>
                  </div>
                  <div>操作人员：{{detailList.user_realname}}</div>
                </el-timeline-item>
                <el-timeline-item size="large" placement="top" v-if="detailList.before_sn">
                  <div>{{detailList.create_time | toTime}}</div>
                  <div>改单</div>
                  <div style="font-size:0.2rem;">订单金额：{{detailList.amount*1}}元</div>
                  <div>商品金额：{{detailList.receivables*1}}元</div>
                  <div v-if="detailList.discount<0">优惠金额：{{-detailList.discount*1}}元</div>
                  <div v-if="detailList.discount>0">多收金额：{{detailList.discount*1}}元</div>
                  <div>支付金额：{{detailList.payment*1}}元</div>
                  <div>赊欠金额：{{detailList.credit*1||0}}元</div>
                  <div
                    v-if="detailList.status && detailList.need_repayment_amount != detailList.order_amount"
                  >
                    支付方式：
                    <span v-if="detailList.pay_type == 1">现金</span>
                    <span v-if="detailList.pay_type == 2">支付宝</span>
                    <span v-if="detailList.pay_type == 3">微信</span>
                    <span v-if="detailList.pay_type == 4">银行卡</span>
                    <span v-if="detailList.pay_type == 5">POS</span>
                    <span v-if="detailList.pay_type == 51">POS</span>
                    <span v-if="detailList.pay_type == 52">POS</span>
                    <span v-if="detailList.pay_type == 53">POS</span>
                  </div>
                  <div>操作人员：{{detailList.user_realname}}</div>

                  <!-- " -->
                  <div style="color:#e36209" @click="tobefore(detailList.before_sn,2)">查看改单前</div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
          <div style="height:0.7rem" v-if="(detailList.status != 3 && detailList.status != 4)"></div>
        </div>
        <div class="fixFooter" v-if="(detailList.status != 3 && detailList.status != 4)">
          <div>
            <div
              class="success"
              v-if="Number(detailList.last_credit)>0"
              @click="handleClickPayment"
            >还款</div>
          </div>
          <div>
            <template v-if="detailList.is_change == 1">
              <div disabled>改单中</div>
            </template>
            <template v-if=" detailList.id && detailList.is_change == 0">
              <div class="success" @click="changeOrder">改单</div>
              <!-- <div class="success" v-if="!detailList.before_sn" @click="changeOrder">改单</div>
              <div disabled v-if="detailList.before_sn">已改单</div> -->
              <div class="warning" @click="deteleData">作废</div>
            </template>
          </div>
        </div>
      </div>
    </md-popup>
    <!-- 还款 -->
    <toPay ref="toPay" @finish="handlePayFinish" />
  </div>
</template>
<script>
import {
  timestampToDate,
  timestampToTime,
  longtimestampToTime,
} from "@/utils/timestamp";
import Cookies from "@/utils/Cookies";
import toPay from "./../buyer/toPay";
import {
  order_list,
  order_delete,
  order_print,
  order_edit,
  order_getCredit,
} from "@/api/work/order.js";
export default {
  name: "orderDetail",
  components: { toPay },
  data() {
    return {
      printLoading: true,
      isPopupShow: this.pop_show,
      detailList: {},
      order_sn: this.orderId,
      before_sn: "",
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
    };
  },
  props: {
    pop_show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: "",
    },
  },
  watch: {
    pop_show: {
      handler(newValue, oldValue) {
        this.isPopupShow = newValue;
      },
      deep: true,
    },
    orderId: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.order_sn = newValue;
          this.detailList = {};
          this.getList(this.order_sn, this.before_sn);
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    //关闭弹窗
    closePop() {
      this.isPopupShow = false;
      this.order_sn = "";
      this.before_sn = "";
      this.$emit("cancel");
      this.$emit("finish");
    },
    //小票打印
    orderPrint() {
      if (this.printLoading) {
        this.printLoading = false;
        try {
          this.$toast.loading("正在打印中");
          // 打印数据
          var p_sub_data = {
            shop_name: JSON.parse(Cookies.get("shopInfo")).shop_name || "",
            date: timestampToTime(this.detailList.create_time),
            buyer_name: this.detailList.buyer_name,
            car_no: this.detailList.buyer_car_no || "",
            casher: JSON.parse(Cookies.get("shopInfo")).realname || "",
            tel: JSON.parse(Cookies.get("userInfo")).mobile || "",
            shop_goods: this.detailList.goods,

            order_sn: this.detailList.order_sn,
            day_num: this.detailList.day_num,
            pay_date: timestampToTime(this.detailList.pay_time),
            remarks: this.detailList.remarks,
            pay_type: this.detailList.pay_type,
            order_amount: this.detailList.receivables,
            payment: this.detailList.payment,
            discount: this.detailList.discount,
          };
          var result = plus.bridge.execSync("sunmiPrint", "printOrder", [
            JSON.stringify(p_sub_data),
          ]);
          this.$toast.hide();
          this.printLoading = true;
        } catch (error) {
          order_print({ order_sn: this.detailList.order_sn })
            .then((res) => {
              this.printLoading = true;
              if (res.code == 200) {
                this.$toast.succeed(res.message);
              }
            })
            .catch((err) => {
              this.$toast.hide();
              this.printLoading = true;
            });
        }
      }
    },
    //获取列表
    getList(order_sn, before_sn) {
      order_list({ order_sn, before_sn }).then((res) => {
        if (res.code == 200) {
          this.detailList = res.data.list[0];
          if (Number(this.detailList.last_credit > 0)) {
            order_getCredit({ id: this.detailList.id }).then((res) => {
              if (res.code == 200) {
                this.detailList.credit_id = res.data.id;
              }
            });
          }
        }
      });
    },

    // 改单
    changeOrder() {
      this.$dialog.confirm({
        title: "确认",
        content: "改单后原订单将被作废，确认修改吗？",
        confirmText: "确定",
        onConfirm: () => {
          order_edit({ order_sn: this.detailList.order_sn }).then((res) => {
            if (res.code == 200) {
              this.$toast.succeed(res.message);
              this.getList(this.order_sn, this.before_sn);
              this.$router.replace({
                path: "/open",
              });
            }
          });
        },
      });
    },
    //
    tobefore(newOrderId, type) {
      console.log("type", type);
      if (type == 1) {
        //查看改单后
        this.order_sn = "";
        this.before_sn = newOrderId;
        this.getList(this.order_sn, this.before_sn);
      } else {
        //查看改单前
        this.before_sn = "";
        this.order_sn = newOrderId;
        this.getList(this.order_sn, this.before_sn);
      }
    },
    // 作废
    deteleData() {
      this.$dialog.confirm({
        title: "确认",
        content: "确认作废该订单吗？",
        confirmText: "确定",
        onConfirm: () => {
          order_delete({ id: this.detailList.id }).then((res) => {
            if (res.code == 200) {
              this.$toast.succeed(res.message);
              this.getList(this.order_sn, this.before_sn);
            }
          });
        },
      });
    },

    // 还款
    handleClickPayment() {
      this.$refs.toPay.showPop(2, {
        buyer_name: this.detailList.buyer_name,
        receivables: this.detailList.last_credit,
        credit_ids: this.detailList.credit_id,
      });
    },

    // 还款完成
    handlePayFinish() {
      this.getList(this.order_sn, this.before_sn);
    },
  },
};
</script>
<style lang="less" scoped>
.detailBox {
  background: #fff;
  width: 6rem;
  height: calc(100% - 0.54rem);
  background: #fff;
  position: relative;
  z-index: 1000;
  .titleBox {
    width: 6rem;
    height: 0.68rem;
    box-shadow: 0 0.02rem 0.04rem 0.02rem #e1e1e1;
    padding: 0 0.24rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .title {
      color: #404040;
      font-size: 0.28rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .printer {
      padding: 0 0.15rem;
      border: 0.01rem solid #31b158;
      color: #31b158;
      font-size: 0.2rem;
      border-radius: 0.04rem;
      height: 0.36rem;
      line-height: 0.34rem;
    }
  }
  .contentBox {
    height: calc(100% - 0.68rem);
    overflow-y: scroll;
    .orderInfoBox {
      .orderInfoTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.58rem;
        margin-left: 0.12rem;
        margin-right: 0.24rem;
        border-bottom: 0.01rem solid #e5e5e5;
        position: relative;
        & > span:nth-child(1) {
          border-left: 0.04rem solid #31b158;
          padding-left: 0.08rem;
        }
        span {
          font-size: 0.24rem;
          color: #404040;
        }
        span:nth-of-type(2) {
          color: #31b158;
        }
      }
      .orderInfoContent {
        padding: 0.17rem 0.24rem 0.2rem 0.24rem;
        & > div {
          display: flex;
        }
        .tit_b {
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 0.16rem;
          div:nth-of-type(1) {
            color: #404040;
            font-size: 0.24rem;
            font-weight: bold;
            font-family: PingFang-SC-Bold;
          }
          div:nth-of-type(2) {
            color: #31b158;
            font-weight: bold;
            span:nth-of-type(1) {
              font-size: 0.16rem;
              font-weight: normal;
            }
          }
        }
        .price_box,
        .line_y,
        .order_num,
        .order_people,
        .order_time {
          margin-bottom: 0.08rem;
          justify-content: space-between;
          color: #404040;
          font-size: 0.2rem;
          div {
            color: #404040;
            font-size: 0.2rem;
            span:nth-of-type(1) {
              // font-size: 0.16rem;
              font-weight: normal;
            }
          }
        }
        .credit_discount {
          > div {
            display: flex;
            align-items: flex-end;
            > span {
              color: #404040;
              font-size: 0.2rem;
            }
            > span:nth-of-type(2) {
              font-size: 0.16rem;
            }
          }
        }
        .line_y {
          justify-content: flex-start;
          div {
            margin-right: 0.3rem;
            div {
              display: flex;
            }
          }
        }
        .desc_box {
          margin-bottom: 0.08rem;
          color: #404040;
          font-size: 0.2rem;
          span:nth-child(1) {
            width: 0.7rem;
          }
        }
        .order_time {
          color: #999999;
          margin-bottom: 0;
        }
      }
    }
    .bgg {
      width: 100%;
      height: 0.1rem;
      background: #f5f5f5;
    }
    .goodsDetailBox {
      // padding-bottom: 0.7rem;
      .tit {
        height: 0.58rem;
        padding: 0 0.12rem;
        border-bottom: 0.01rem solid #e5e5e5;
        color: #404040;
        font-size: 0.24rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          border-left: 0.04rem solid #31b158;
          padding-left: 0.08rem;
        }
      }
      .goodsList {
        padding: 0 0.24rem;
        .list {
          padding-top: 0.16rem;
          // padding-bottom: 0.2rem;
          // border-bottom: 0.01rem solid #e5e5e5;
          font-size: 0.2rem;
          color: #999;
          & > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.1rem;
          }
          .name {
            color: #404040;
            display: flex;
            align-items: flex-end;
            & > div:nth-child(1) {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              > .goods_name {
                color: #404040;
                font-size: 0.24rem;
                font-weight: bold;
                margin-right: 0.1rem;
                max-width: 2rem;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
            & > div:nth-child(2) {
              .total {
                color: #31b158;
                font-size: 0.24rem;
                font-weight: bold;
              }
            }
          }
          .bale {
            color: #404040;
          }
          div:nth-of-type(3) {
            justify-content: center;
            table {
              border: 0.01rem solid #ccc;
              width: 100%;
              tr {
                td {
                  height: 0.45rem;
                  width: 1.8rem;
                  text-align: center;
                  border: 0.01rem solid #ccc;
                }
              }
            }
          }
        }
      }
    }
    .orderPart3 {
      .contentPart3 {
        padding: 0.3rem 0.3rem;
        div {
          font-size: 0.2rem;
          color: #666;
        }
      }
    }
  }
  .fixFooter {
    position: absolute;
    width: 6rem;
    height: 0.74rem;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 50;
    box-shadow: 0 0 0.08rem 0 rgba(30, 30, 30, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.12rem;
    & > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > div {
        width: 1.2rem;
        height: 0.48rem;
        line-height: 0.48rem;
        border-radius: 0.04rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0.12rem;
        &[disabled] {
          background-color: #ccc !important;
          color: #fff !important;
          border-color: #ccc !important;
        }
        &.success {
          background: #31b158;
          color: #fff;
        }
        &.warning {
          background: #f56c6c;
          color: #fff;
        }
      }
    }
  }
}
</style>
<style lang="less">
// .listBox {
//   height: 626px;
//   .scroll-view-item {
//     padding: 30px 0;
//     text-align: center;
//     font-size: 32px;
//     border-bottom: 0.5px solid #efefef;
//   }
// }
.orderDetail .orderDetail_pop .md-popup-mask {
  top: 0.54rem;
  left: 0.7rem;
}
.orderDetail .md-popup.right .md-popup-box {
  width: 6rem;
  background: #fff;
  margin-top: 0.54rem;
}
</style>